import React, { createContext, useState } from 'react';

// Créer le contexte
export const UserContext = createContext();

// Créer un fournisseur de contexte
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [nbnotif, setNbnotif] = useState(0);

  return (
    <UserContext.Provider value={{ user, setUser, loading, setLoading, nbnotif, setNbnotif }}>
      {children}
    </UserContext.Provider>
  );
};